import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-equal",
  "use": "icon-equal-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol viewBox=\"0 0 13 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-equal\">\n  <path d=\"M0.2 0.52H12.32V2.128H0.2V0.52ZM0.2 5.44H12.32V7.072H0.2V5.44Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol